module.exports = __webpack_public_path__ + "static/img/preview.903662e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/preview.jpg
// module id = kI8M
// module chunks = 1